"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBDef_TranslationClient = void 0;
const ts_common_1 = require("@nu-art/ts-common");
const Validator_ModifiableProps = {
    accountId: ts_common_1.tsValidateUniqueId,
    companyName: (0, ts_common_1.tsValidateString)(),
    details: (0, ts_common_1.tsValidateString)(),
};
const Validator_GeneratedProps = {};
exports.DBDef_TranslationClient = {
    generatedPropsValidator: Validator_GeneratedProps,
    modifiablePropsValidator: Validator_ModifiableProps,
    versions: ['1.0.0'],
    dbName: 'translation-client',
    entityName: 'translation-client',
};
